import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import { Check, InfoOutlined, LocationOn } from "@mui/icons-material";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { userState } from "src/store/user/userState";
import { grey } from "@mui/material/colors";
import { useTheme } from "@emotion/react";
import {
  errorsFormRegisterState,
  errorsReservationGuestState,
  errorsReservationUserState,
  valuesFormRegisterState,
  valuesFormReservationGuestState,
  valuesFormReservationUserState,
} from "src/Patient/state/atoms";
import ProfessionalName from "src/Professional/ProfessionalName";
import ProfessionalSpecialities from "src/Professional/ProfessionalSpecialities";
import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import { useEffect } from "react";
import ModalTitleCustom from "src/shared/components/modals/ModalTitle";

import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import { useWaitList } from "./hooks/useWaitList";
import TabsWaitList from "./TabsWaitList";
import AutocompleteProfessionals from "./components/AutocompleteProfessionals";
import AutocompleteSpecialities from "./components/AutocompleteSpecialities";
import InputFechaIni from "./components/InputFechaIni";
import InputFechaFin from "./components/InputFechaFin";
import {
  errorsWaitListState,
  fechaFinWaitListState,
  fechaIniWaitListState,
  professionalWaitListState,
  specialityWaitListState,
} from "./state/atoms";
import Informacion from "./components/Informacion";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  ".contFechaLogeado": {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  ".contFechaNoLogeado": {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },

  ".prestador": {
    marginTop: "1rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
  },

  ".formularioAcceso": {
    margin: 0,
    height: "100%",
    width: "100%",
    alignItems: "center",
  },

  [theme.breakpoints.up("xs")]: {
    ".contFechaNoLogeado": {
      padding: "1rem 0",
    },
  },

  [theme.breakpoints.up("md")]: {
    ".contFechaNoLogeado": {
      paddingRight: "1rem",
    },

    ".usuarioLogeado": {
      padding: "1rem",
    },

    ".usuarioSinLogear": {
      padding: "1rem",
    },
  },
}));

export default function ModalWaitList({ open, onClose }) {
  const resetErrorsFormGuest = useResetRecoilState(errorsReservationGuestState);
  const setValuesFormReservationGuest = useSetRecoilState(valuesFormReservationGuestState);
     const resetValuesFormGuest = ()=>{
         setValuesFormReservationGuest((prev)=>{
             return {
                 ...prev,
                 usuApePat: null,
                 usuApeMat: null,
                 usuNombres: null,
                 usuFono: null,
                 usuCelular: null,
                 ageEmail: null,
                 ageEmailConfirm: null,
                 fechaNac: null,
                 isaCodigo: null,
             }
         })
     }
  const resetErrorsFormUser = useResetRecoilState(errorsReservationUserState);
  const resetValuesFormUser = useResetRecoilState(
    valuesFormReservationUserState
  );
  const resetValuesFormUserRegister = useResetRecoilState(
    valuesFormRegisterState
  );
  const resetErrorsFormRegister = useResetRecoilState(errorsFormRegisterState);
  const user = useRecoilValue(userState);

  const [ocultar, setOcultar] = useState(false);

  const checkForDevice = () => window.innerWidth < 640;
  const [isMobile, setIsMobile] = useState(checkForDevice());

  let { handleClickSaveWaitList, loadingSaved, hourSelected, setHourSelected } =
    useWaitList();

  const theme = useTheme();

  const resetProfessional = useResetRecoilState(professionalWaitListState);
  const resetSpeciality = useResetRecoilState(specialityWaitListState);
  const resetFechaIni = useResetRecoilState(fechaIniWaitListState);
  const resetFechaFin = useResetRecoilState(fechaFinWaitListState);
  const resetErrorsWaitList = useResetRecoilState(errorsWaitListState);

  const handleClose = (ev, reason) => {
    if (reason && reason === "backdropClick") return;
    resetProfessional();
    resetSpeciality();
    resetFechaIni();
    resetFechaFin();
    resetErrorsWaitList();
    resetErrorsFormGuest();
    resetValuesFormGuest();
    resetErrorsFormUser();
    resetValuesFormUser();
    resetValuesFormUserRegister();
    setHourSelected(null);
    onClose();
    resetErrorsFormRegister();

    setOcultar(false);
  };

  useEffect(() => {
    return () => {
      resetErrorsFormGuest();
      resetValuesFormGuest();
      resetErrorsFormUser();
      resetValuesFormUser();
      resetValuesFormUserRegister();
      resetErrorsFormRegister();
    };
  }, []);

  //VALIDAR MOBILE O WEB
  useEffect(() => {
    const handlePageResized = () => {
      setIsMobile(checkForDevice());
    };

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handlePageResized);
      window.addEventListener("orientationchange", handlePageResized);
      window.addEventListener("load", handlePageResized);
      window.addEventListener("reload", handlePageResized);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handlePageResized);
        window.removeEventListener("orientationchange", handlePageResized);
        window.removeEventListener("load", handlePageResized);
        window.removeEventListener("reload", handlePageResized);
      }
    };
  }, []);

  const confirmar = async () => {
    const flag = await handleClickSaveWaitList();

    if (flag) onClose();
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <BootstrapDialog
        maxWidth={"lg"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <ModalTitleCustom id="customized-dialog-title" onClose={handleClose}>
          Confirmar Inscripción Lista de Espera
        </ModalTitleCustom>

        <DialogContent>
          <Grid container>
            <Grid
              container
              item
              xs={12}
              md={5}
              style={{ height: "fit-content" }}
            >
              {hourSelected && (
                <Grid className="prestador">
                  <Grid width={64}>
                    <ProfessionalPhoto
                      width={64}
                      height={100}
                      image={hourSelected?.professional?.imagen}
                      alt={hourSelected?.professional?.ptdNombre}
                    />
                  </Grid>

                  <Grid ml={1}>
                    <ProfessionalName
                      fontSize={20}
                      nameProfessional={hourSelected?.professional.ptdNombre}
                    />
                    <ProfessionalSpecialities
                      specialities={hourSelected?.professional.especialidades}
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12}>
                <Informacion />
              </Grid>
              {hourSelected && (
                <Grid
                  container
                  className={
                    user.isAuthenticated
                      ? "contFechaLogeado"
                      : "contFechaNoLogeado"
                  }
                  borderBottom={`1px solid ${theme.palette.default.main}`}
                >
                  <Grid item className="sedeConfirmada" alignContent={"center"}>
                    <Typography
                      display={"flex"}
                      alignItems={"center"}
                      fontWeight={500}
                      color={theme.palette.secondary.main}
                    >
                      <LocationOn
                        style={{ color: grey[300], marginRight: 5 }}
                      />
                      {hourSelected?.professional.sede}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
            {!user.isAuthenticated && (
              <Grid
                item
                xs={12}
                md={7}
                className="formularioAcceso"
                style={{ border: `2px solid ${theme.palette.default.main}` }}
              >
                <TabsWaitList />
              </Grid>
            )}
            {user.isAuthenticated && !hourSelected && (
              <Grid
                item
                xs={12}
                md={7}
                className="formularioAcceso"
                style={{ border: `2px solid ${theme.palette.default.main}` }}
                padding={2}
              >
                <Grid item xs={12}>
                  <AutocompleteSpecialities
                    styles={{
                      width: "100%",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutocompleteProfessionals
                    styles={{
                      width: "100%",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFechaIni />
                </Grid>
                <Grid item xs={12}>
                  <InputFechaFin />
                </Grid>
              </Grid>
            )}
            {user.isAuthenticated && hourSelected && (
              <Grid
                item
                xs={12}
                md={7}
                className="formularioAcceso"
                style={{ border: `2px solid ${theme.palette.default.main}` }}
                padding={2}
              >
                <Grid item xs={12}>
                  <AutocompleteSpecialities
                    styles={{
                      width: "100%",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutocompleteProfessionals
                    styles={{
                      width: "100%",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFechaIni />
                </Grid>
                <Grid item xs={12}>
                  <InputFechaFin />
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonCustom
            loading={loadingSaved}
            color="secondary"
            onClick={confirmar}
            text="CONFIRMAR INSCRIPCIÓN"
            icon={<Check />}
          />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
